import React from 'react';

import { Wrapper } from './Block.jsx';
import Name from '../utility/Name.jsx';
import Token from '../utility/Token.jsx';
import TypeConfig from '../utility/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

import { default as ClickToken } from '../../../../../artcloud.click/source/scripts/common/Token.jsx';

function BaseTextComponent(props) {
    if (!props.builder && props.content != undefined && props.content.length == 0) {
        return null;
    }
    const { contentContainerStyle, contentStyle, innerStyle, wrapperStyle} = Utilities.parseTextWrapperConfig(props.blockConfig);
    return (
        <Wrapper {...props} className="mcnTextBlock" style={wrapperStyle}>
            <td align="center" className="mcnTextBlockInner" style={innerStyle} valign="top">
                <table
                    border="0"
                    cellPadding="0"
                    cellSpacing="0"
                    className="mcnTextContentContainer"
                    style={contentContainerStyle}>
                    <tbody>
                        <tr>
                            <td
                                className="mcnTextContent"
                                dangerouslySetInnerHTML={{ __html: props.content }}
                                style={contentStyle}
                                valign="top" />
                        </tr>
                    </tbody>
                </table>
            </td>
        </Wrapper>
    )
}
const BaseTextTypeConfig = {
    panel: {
        block: function ({ backgroundColor, context, design }) {
            const group = 'block';
            return {
                group,
                label: 'Content',
                options: [
                    {
                        display: 'Design Your Content',
                        group,
                        includeGroupOption: false,
                        name: 'design',
                        type: 'rich-text-campaign',
                        value: design
                    },
                    {
                        display: 'Background Color',
                        group,
                        name: 'backgroundColor',
                        type: 'color',
                        value: backgroundColor
                    },
                    {
                        display: 'Content Background Color',
                        group,
                        name: 'contentColor',
                        type: 'color'
                    },
                    {
                        display: 'Border Radius',
                        group,
                        name: 'borderRadius',
                        options: TypeConfig.options.measurement(),
                        type: 'measurement'
                    },
                    {
                        display: 'Border',
                        group,
                        name: 'border',
                        options: TypeConfig.options.measurement(),
                        type: 'border'
                    }
                ]
            }
        },
        layout: function () {
            const group = 'layout';
            return {
                group,
                label: 'Layout',
                options: [
                    {
                        display: 'Padding/Margin',
                        group,
                        max: '100',
                        name: 'paddingMargin',
                        options: TypeConfig.options.measurement(),
                        type: 'paddingMargin',
                        value: {
                            paddingBottom: { value: '18', unit: 'px' },
                            paddingLeft: { value: '18', unit: 'px' },
                            paddingRight: { value: '18', unit: 'px' },
                            paddingTop: { value: '18', unit: 'px' }
                        }
                    }
                ]
            };
        }
    }
};
const BaseText = { Component: BaseTextComponent, TypeConfig: BaseTextTypeConfig };

// region HEADER TEXT

const HeaderTextTypeConfig = {
    defaultDesign: () => `<p class="p" style="margin:0;padding:0;"><span style="color:#222222;font-family:${TypeConfig.defaultFontFamily};font-size:40px;font-weight:bold;line-height:60px;vertical-align:middle;">Header</span></p>`,
    panel: {
        block: (context) => BaseTextTypeConfig.panel.block({ context, design: HeaderTextTypeConfig.defaultDesign() }),
        layout: BaseTextTypeConfig.panel.layout
    }
}
const HeaderTextBlockTypeDefinition = (group, context) => {
    return {
        id: Name.Block.HeaderText,
        config: {
            block: HeaderTextTypeConfig.panel.block(context),
            layout: HeaderTextTypeConfig.panel.layout()
        },
        display: 'Header',
        group,
        image: 'heading.png'
    };
}
const HeaderText = { BlockTypeDefinition: HeaderTextBlockTypeDefinition, Component: TokenizedTextComponent, TypeConfig: HeaderTextTypeConfig };

// TOKENIZED TEXT

function TokenizedTextComponent(props) {
    const parseContent = (tokenizedString) => {
        if (!tokenizedString) {
            return '';
        }
        return ClickToken.parseTokenizedString(tokenizedString, (keyword) => {
            let replaceString = '';
            switch (keyword) {
                case Token.Company:
                case Token.FirstName:
                case Token.LastName:
                case Token.Prefix:
                case Token.SpouseFirstName:
                case Token.SpouseLastName:
                case Token.SpousePrefix:
                    replaceString = `*|${keyword}|*`
                    break;
            }
            return replaceString;
        });
    }
    const design = props.blockConfig && props.blockConfig.block && props.blockConfig.block.design;
    const [content, setContent] = React.useState(undefined);
    React.useEffect(() => {
        setContent(parseContent(props.blockConfig.block.design));
    }, [design]);

    if (props.serverSide && content == undefined) {
        setContent(parseContent(props.blockConfig.block.design));
    }
    return <BaseTextComponent {...props} content={content} />
}
const TokenizedTextTokens = () => {
    return [
        Token.getDefaultTokenConfig('Prefix', Token.Prefix),
        Token.getDefaultTokenConfig('First Name', Token.FirstName),
        Token.getDefaultTokenConfig('Last Name', Token.LastName),
        Token.getDefaultTokenConfig('Spouse Prefix', Token.SpousePrefix),
        Token.getDefaultTokenConfig('Spouse First Name', Token.SpouseFirstName),
        Token.getDefaultTokenConfig('Spouse Last Name', Token.SpouseLastName),
        Token.getDefaultTokenConfig('Company', Token.Company)
    ];
}
const TokenizedTextTypeConfig = {
    defaultDesign: () => `<p class="p" style="margin:0;padding:0;"><span style="color:#757575;font-family:${TypeConfig.defaultFontFamily};font-size:16px;line-height:24px;vertical-align:middle;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</span></p>`,
    panel: {
        block: (context) => BaseTextTypeConfig.panel.block({ context, design: TokenizedTextTypeConfig.defaultDesign() }),
        layout: BaseTextTypeConfig.panel.layout
    }
}
const TokenizedTextBlockTypeDefinition = (group, context) => {
    return {
        id: Name.Block.Text,
        config: {
            block: TokenizedTextTypeConfig.panel.block(context),
            layout: TokenizedTextTypeConfig.panel.layout()
        },
        display: 'Text',
        group,
        image: 'text.png'
    };
}
const TokenizedText = { BlockTypeDefinition: TokenizedTextBlockTypeDefinition, Component: TokenizedTextComponent, Tokens: TokenizedTextTokens, TypeConfig: TokenizedTextTypeConfig };

export { BaseText, HeaderText, TokenizedText };